import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';

import type { OdooAuthResponse } from '@/lib/odooAuth';

export type OdooRole = 'admin' | 'user' | null;

export const odooAuthVar = makeVar<null | OdooAuthResponse>(null);

export function setOdooAuth(auth: null | OdooAuthResponse) {
  odooAuthVar(auth);
}

export function useOdooAuth() {
  const odooAuth = useReactiveVar(odooAuthVar);
  const department = odooAuth?.department ?? null;
  const role: OdooRole = odooAuth?.role ?? null;

  return { department, odooAuth, role, setOdooAuth };
}
